let serverProps;

export function getServerProps() {
  // grab the node which contains props
  const serverPropsNode = document.getElementById('server-props');

  // grab innerHTML (which is the props as JSON); default to strignified empty object
  const serverPropsJSON =
    (serverPropsNode && serverPropsNode.innerHTML) || '{}';

  // parse the JSON strings to JavaScript objects
  // TODO: Consider wrapping these in try/catches
  try {
    serverProps = JSON.parse(serverPropsJSON);
  } catch (e) {
    serverProps = {};
  }
  return serverProps;
}
